import store from "@/store";

function normalizeUnitFromGetResponse(response) {
  if (!response) return null;
  if (response.data && response.data.id != null) return response.data;
  if (response.id != null) return response;
  return null;
}

export async function ensureUnitLoadedForWizard(unitId) {
  const id = Number(unitId);
  if (!Number.isFinite(id)) return null;
  try {
    await store.dispatch("unit/getAll", { with: "router:id,id_tenant" });
  } catch (_) {
  }
  const fromStore = store.getters["unit/getItemById"](id);
  if (fromStore) return fromStore;
  try {
    const response = await store.dispatch("unit/get", id);
    const unit = normalizeUnitFromGetResponse(response);
    if (unit && unit.id != null) return unit;
  } catch (_) {
  }
  return null;
}

export function getUnitSnapshotForWizardPrefill(row, unitId) {
  const id = Number(unitId);
  if (!Number.isFinite(id)) return undefined;
  const unit = row && row.unit;
  if (!unit || Number(unit.id) !== id) return undefined;
  const hasDetail =
    unit.description != null ||
    unit.router != null ||
    unit.rems !== undefined ||
    unit.sirh !== undefined;
  if (!hasDetail) return undefined;
  return unit;
}
